import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme/palette';
import { SvgIconProps } from './SvgIcon.types';

export const ExportIcon = memo(({ className, fontSize = 24, color = colors.primary.main }: SvgIconProps) => {
  return (
    <SvgIcon className={className} style={{ fontSize }} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M18.0898 9.04439L12.0454 2.99995L6.00095 9.04439H9.37873V14.9999C9.37873 15.3555 9.6454 15.7111 10.0898 15.7111H14.0898C14.4454 15.6222 14.7121 15.3555 14.7121 14.9999V8.9555H18.0898V9.04439Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M22 17.0443V19.711C22 20.4221 21.3778 21.0443 20.6667 21.0443H3.33333C2.62222 21.0443 2 20.4221 2 19.711V17.0443"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
});
